import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';

export const makeSelectorProductTranslation = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.products,
    );
